import { useState } from "react";
import { FormContext } from "./FormContext";

const initialState = {
  name: "",
  email: "",
  phone: "",
  city: "",
  typeofservice: "",
  message: "",
};

export const ContactFormProvider = ({ children }) => {
  const [formData, setFormData] = useState(initialState);

  return (
    <FormContext.Provider value={{ formData, setFormData }}>
      {children}
    </FormContext.Provider>
  );
};
